var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00037 12C2.00037 6.48 6.48037 2 12.0004 2C17.5204 2 22.0004 6.48 22.0004 12C22.0004 17.52 17.5204 22 12.0004 22C6.48037 22 2.00037 17.52 2.00037 12ZM11.0004 16H9.00037V8H11.0004V16ZM12.0004 20C7.59037 20 4.00037 16.41 4.00037 12C4.00037 7.59 7.59037 4 12.0004 4C16.4104 4 20.0004 7.59 20.0004 12C20.0004 16.41 16.4104 20 12.0004 20ZM15.0004 16H13.0004V8H15.0004V16Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopService);
export default __webpack_public_path__ + "static/media/StopService.4733c1fdc7d234d76d1a4cd072e8492d.svg";
export { ForwardRef as ReactComponent };